import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-camera-comprator',
    templateUrl: './camera-comprator.component.html',
    styleUrls: ['./camera-comprator.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CameraCompratorComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
